import { useEffect, useState } from 'react';
import { useAuth } from '../../../contexts/AuthProvider';
import { PageContainer } from '../../../components/PageContainer';
import { NotFound } from '../../../components/NotFound';
import { Card, Dropdown, Form } from 'react-bootstrap';
import { useUtility } from '../../../contexts/UtilityContext';
import { Modal } from '../../../components/Modal';
import StatusBadge from '../../../components/StatusBadge';
import { BrandModel, fetchBrandList } from '../../../model/brand.model';
import { BrandForm } from './brand-form';
import { Actions } from '../../../components/Actions';

export default function BrandList() {
  const [list, setList] = useState<Array<BrandModel>>([]);
  const [filterList, setFilterList] = useState<Array<BrandModel>>([]);
  const { authInfo } = useAuth();
  const { isLoading, showLoader, hideLoader, confirm } = useUtility();
  const [selectedBrand, setSelectedBrand] = useState<BrandModel>();

  function handleEdit(brand: BrandModel) {
    setSelectedBrand(brand);
  }

  async function handleDelete(brand: BrandModel) {
    try {
      const isConfirmed = await confirm(`Are you want to delete the Brand: ${brand.brand_name}`);
      if (isConfirmed && brand.id) {
        // await deleteBrand(item.id, authInfo);
        setList(prev => prev.filter(p => p.id !== brand.id));
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        showLoader();
        const res = await fetchBrandList(authInfo);
        setList(res);
        setFilterList(res);
      } catch (err) {
        console.error(err);
      } finally {
        hideLoader();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authInfo]);
  return (
    <>
      <PageContainer
        title="Brand Master"
        addButtonHandler={() => setSelectedBrand({} as BrandModel)}
        body={
          !isLoading && list.length === 0 ? <NotFound /> : <>
          <Form.Group className="mb-3" controlId="brandSearch">
              <Form.Control
                type="text"
                placeholder="Search by brand name..."
                onChange={(e) => {
                  const keyword = e.target.value.toLowerCase();
                  setFilterList(
                    list.filter(brand => brand.brand_name.toLowerCase().includes(keyword))
                  );
                }}
              />
            </Form.Group>
            {filterList.map((brand, index) => (
              <Card key={`card-${index}`} className="mb-3">
                <Card.Body>
                  <Card.Title className="d-flex justify-content-between align-items-center">
                    <span>{brand.brand_name}</span>
                    <Actions index={index}>
                      <Dropdown.Item onClick={() => handleEdit(brand)}>Edit</Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(brand)}>Delete</Dropdown.Item>
                    </Actions>
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    <StatusBadge value={brand.publish} />
                  </Card.Subtitle>
                </Card.Body>
              </Card>
            ))}
          </>
        }
      />
      <Modal
        title={selectedBrand?.brand_name ?? "Brand Master"}
        show={!!selectedBrand}
        handleClose={() => setSelectedBrand(undefined)}
        fullscreen
      >
        <BrandForm
          brand={selectedBrand}
          onSuccess={(brand) => {
            setList(prev => {
              const exists = prev.findIndex(p => p.id === brand.id);
              if (exists !== -1) {
                const updated = [...prev];
                updated[exists] = brand;
                return updated;
              }
              return [...prev, brand];
            });
            setSelectedBrand(undefined);
          }}
        />
      </Modal>
    </>
  );
};